import React from 'react';
import { useSelector } from 'react-redux';
import Avatar from 'src/components/base/Avatar/Avatar';
import { Typography } from "src/latest/src/components";

interface Prop {
  selfUser?: boolean;
  className?: string;
}

const NoRemoteVideoView: React.FC<Prop> = ({ selfUser,className }) => {
  const { loggedInUser } = useSelector((state: any) => state.authentication);
  const { attendees } = useSelector((state: any) => state.teleTherapy);

  const otherAttendee = selfUser
    ? attendees.find((a: any) => a.id === loggedInUser.id)
    : attendees.find((a: any) => a.id !== loggedInUser.id);

  return (
    <div className={`${className} d-flex justify-content-center align-items-center`}>
      {attendees.length === 2 ? (
        <div className="d-flex justify-content-center align-items-center h-full no-video no-video-wrapper">
          {otherAttendee && (
            <div className="d-flex flex-column align-items-center">
              <Avatar
                className="w-24 h-24"
                photoUrl={otherAttendee.image}
                fullName={otherAttendee.fullName}
                size={'120px'}
              />
              <Typography
                variant="size-26"
                weight="regular"
                color={'color-3'}
                className="mt-4"
              >
                {otherAttendee.fullName}
              </Typography>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center justify-center h-full" />
      )}
    </div>
  );
};

export default NoRemoteVideoView;
